import * as api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";

export const checkVoucherValidity: ApiMethod<
  api.Server.CheckVoucherValidityInput,
  boolean,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new api.Server.Server_Vouchers_Client(
          undefined,
          api.apiClient
        );

        return client.vouchers_checkValidity_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const redeemVoucher: ApiMethod<
  api.Server.RedeemVoucherInput,
  boolean,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new api.Server.Server_Vouchers_Client(
          undefined,
          api.apiClient
        );

        return client.vouchers_redeem_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const redeemB2BVoucher: ApiMethod<
  api.Server.ConsumeBusinessGroupVoucherInput,
  boolean,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new api.Server.Server_BusinessGroupVoucher_Client(
          undefined,
          api.apiClient
        );

        return client.businessGroupVoucher_consume_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const setAutoPlay: ApiMethod<
  api.Server.SetUserAutoplayDisabledInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new api.Server.Server_Account_Client(
            undefined,
            api.apiClient
          );

          return client.account_autoplay_put_V1(data);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const setNextTitle: ApiMethod<
  api.Server.SetUserNextTitleDisabledInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new api.Server.Server_Account_Client(
            undefined,
            api.apiClient
          );

          return client.account_nextTitle_put_V1(data);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getDownloads: ApiMethod<
  void,
  api.Server.DownloadedItemOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new api.Server.Server_Downloads_Client(
          undefined,
          api.apiClient
        );

        return client.downloads_ids_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const removeMultiDownloads: ApiMethod<
  api.Server.RemoveMultiDownloadContentEntityInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new api.Server.Server_Downloads_Client(
          undefined,
          api.apiClient
        );

        return client.downloads_removeMulti_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};
